import { render, staticRenderFns } from "./MembershipsList.vue?vue&type=template&id=bc9cb71c&"
import script from "./MembershipsList.vue?vue&type=script&lang=js&"
export * from "./MembershipsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports